import { render, staticRenderFns } from "./buykc.vue?vue&type=template&id=e64ebd88&"
import script from "./buykc.vue?vue&type=script&lang=js&"
export * from "./buykc.vue?vue&type=script&lang=js&"
import style0 from "./buykc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports